"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import _isUndefined from 'lodash/isUndefined';
/**
 * settings: {
 *      xValue: '',
 *      xPath: '',
 *      yValue: '',
 *      yPath: ''
 * }
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var xValue = '';
    var yValue = '';
    if (settings.xValue) {
      xValue = settings.xValue;
    } else if (settings.xPath) {
      xValue = (0, _get2["default"])(row, settings.xPath);
    } else {
      xValue = value;
    }
    if (settings.yValue) {
      yValue = settings.yValue;
    } else if (settings.yPath) {
      yValue = (0, _get2["default"])(row, settings.yPath);
    } else {
      yValue = value;
    }
    if ((0, _isNil2["default"])(yValue) || (0, _isNil2["default"])(xValue)) {
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-xofy')
    }, /*#__PURE__*/_react["default"].createElement("span", null, xValue), "/", /*#__PURE__*/_react["default"].createElement("span", null, yValue));
  };
};